import { SEARCH_CRITERIA_API_BASE, CODE_PARAM, SEARCH_CRITERIA_API_KEY } from '../Constants/APIConstants';

const getSearchCriteria = (location) => {
    let url = new URL(`${SEARCH_CRITERIA_API_BASE}${location}`);
    url.searchParams.append(CODE_PARAM, SEARCH_CRITERIA_API_KEY);

    return fetch(url, {});
}

export default getSearchCriteria;